import React from "react";
import { Helmet } from "react-helmet";

const Title = ({ title, description, keywords }) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />
		</Helmet>
	);
};

Title.defaultProps = {
	title: "Pharmacie Rd Point Segou",
	description: "We sell the best Healthcare products in town",
	keywords: "Medicaments, Parapharmacie, conseil",
};

export default Title;